module.exports = __webpack_public_path__ + "assets/img/Pioneer_Cozzarolo.faa50e93-ps.jpg";